<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Form from "@components/form/Form.svelte";
	import Input from "@components/form/Input.svelte";
	import { Auth } from "@utils/Auth.svelte.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import { createReactiveBreakpoint } from "@core/utils/createReactiveBreakpoint.js";
	import { expectErrorMessage } from "@core/utils/expectErrorMessage.js";
	import { createPromiseWithStatus } from "@core/utils/svelte/createPromiseWithStatus.svelte.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./ForgotPassword.translations.json" with { type: "json" };

	const { isLegacy, email }: { isLegacy: boolean; email?: string } = $props();
	const { tenant } = getGlobalTemplateProps();
	const forgetPassword = createPromiseWithStatus(Auth.forgotPassword.bind(Auth, tenant.locale));
	const translate = getTranslate(translations);
	const isDesktop = createReactiveBreakpoint(">md");

	async function handleForgotPassword(_event: SubmitEvent, form: HTMLFormElement): Promise<void> {
		const formData = new FormData(form);
		await forgetPassword.call(formData.get("email") as string);
	}

	const error = $derived(
		forgetPassword.value.status === "error" &&
			expectErrorMessage(
				forgetPassword.value.error,
				tenant.locale,
				{
					NotFoundError: translate("notFoundError"),
					IdpError: translate("idpError"),
				},
				translate("unknownError"),
			),
	);
</script>

<Form class="flex flex-col items-stretch gap-4 md:gap-6 mt-2 md:mt-0" onsubmit={handleForgotPassword}>
	<p class="text-fcrgray text-sm/6 md:text-base max-w-127">
		<Formatted text={isLegacy ? translate("legacyRecoveryInfo") : translate("info")} />
	</p>
	<Input required autocomplete="email" placeholder={translate("yourEmail")} value={email} name="email" type="email" />
	<Button
		loading={forgetPassword.value.status === "loading"}
		variant={ButtonVariant.Dark}
		size={isDesktop.current ? ButtonSize.Large : ButtonSize.Medium}
	>
		<Formatted text={translate("sendButton")} />
	</Button>
	{#if error}
		<p class="text-sm text-fcrerror mt-2 [&_a]:text-fcrbrown">
			<Formatted text={error} />
		</p>
	{/if}
</Form>
